module.exports = __webpack_public_path__ + "static/media/cyan.09de6e7c.JPG";